// @ts-nocheck

import React, { useState } from 'react';

import { FloatingWtvContext } from '../../contexts/FloatingWtvContext';

/**
 * @param {Node} children all the necessary node elements we need
 *
 * @return {Node} the provider with the children
 */
const FloatingWtvProvider = ({ children }) => {
  const [placeholderRef, setPlaceholderRef] = useState(null);
  const [floatingWtvRef, setFloatingWtvRef] = useState(null);
  const [offsetTop, setOffsetTop] = useState(null);
  const [isSticky, setIsSticky] = useState(false);

  const value = {
    floatingWtvRef,
    isSticky,
    offsetTop,
    placeholderRef,
    setFloatingWtvRef,
    setIsSticky,
    setOffsetTop,
    setPlaceholderRef,
  };
  return <FloatingWtvContext.Provider value={value}>{children}</FloatingWtvContext.Provider>;
};

export default FloatingWtvProvider;
